import { useCallback, useMemo } from 'react';

import { useAuth } from '@/hooks';
import { monetaryFormat } from '@/utils';

export const QUERY_PRODUCT_SLUG = 'consult-gr';
export const REGISTER_PRODUCT_SLUG = 'register-gr';
export const QUERY_PRICE_FALLBACK = 5.0;
export const REGISTER_PRICE_FALLBACK = 15.0;

const getPriceOrFallback = (fallback: number, price?: number): string => {
  const value = price || fallback;
  return monetaryFormat(value);
};

export const usePrice = () => {
  const auth = useAuth();

  const products = useMemo(() => {
    if (!auth.loaded) return [];
    return auth.user?.company?.combo?.products ?? [];
  }, [auth.loaded]);

  const getPriceBySlug = useCallback((key: string) => products.find(({ slug }) => slug === key)?.price, [products]);

  const registerPrice = useMemo(
    () => getPriceOrFallback(REGISTER_PRICE_FALLBACK, getPriceBySlug(REGISTER_PRODUCT_SLUG)),
    [products]
  );

  const queryPrice = useMemo(
    () => getPriceOrFallback(QUERY_PRICE_FALLBACK, getPriceBySlug(QUERY_PRODUCT_SLUG)),
    [products]
  );

  return { registerPrice, queryPrice };
};
